import { NotificationItem } from '../types';

let id = 0;

export const buildTextNotification = ({ text }: Pick<NotificationItem, 'text'>): NotificationItem => ({
  id: `${++id}`,
  text,
  isOpen: true,
});

export const buildTextAndIconNotification = ({
  text,
  icon,
}: Pick<NotificationItem, 'text'> & Pick<NotificationItem, 'icon'>): NotificationItem => ({
  id: `${++id}`,
  text,
  icon,
  isOpen: true,
});

export const buildTextAndActionNotification = ({
  text,
  action,
}: Pick<NotificationItem, 'text'> & Pick<NotificationItem, 'action'>): NotificationItem => ({
  id: `${++id}`,
  text,
  action,
  isOpen: true,
});

export const buildMaxConfigNotification = ({
  text,
  icon,
  action,
}: Pick<NotificationItem, 'text'> &
  Pick<NotificationItem, 'icon'> &
  Pick<NotificationItem, 'action'>): NotificationItem => ({
  id: `${++id}`,
  text,
  action,
  icon,
  isOpen: true,
});
